import React from "react";
import iconXml from "../../img/icons-ext-file/iconXml.png"

export default function FileXml() {
    return (
        <img src={iconXml} alt="" />
    );
}